import { makeStyles } from '@material-ui/core';
import ContentWrapper from '../../Wrappers/ContentWrapper';
import FilesDragAndDrop from '../../Shared/FilesDragAndDrop';
import { useSelector } from 'react-redux';
import { getTransitionWithVariable } from '../../../redux_store';
import { useAccountName } from 'hooks/useAccountName';
import { FAKE_TITLE_DATA } from '../../Shared/FakeDataGenerator';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  link: {
    fontSize: 16,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));


const ProvidersUpload = () => {
  const { en: { titles } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  const { name: accountName, loading: accountLoading } = useAccountName();
  const steps = [titles.selectAndUploadFile, getTransitionWithVariable(titles.itemSuccessfullyImported, {
    item: titles.providers,
  })];

  return (
    <ContentWrapper
      titleText={
        accountLoading
          ? FAKE_TITLE_DATA
          : getTransitionWithVariable(titles.providersUploadForAccount, {
              accountName,
            })
      }
      className={classes.paper}
    >
      <FilesDragAndDrop
        hasValidation={false}
        name={'appointment-providers'}
        steps={steps}
      />
    </ContentWrapper>
  );
};

export default ProvidersUpload;
